import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { PATH } from '~/constants/route-path';
import {
  StyledContainer,
  StyledCreateButton,
  StyledImage,
  StyledText,
  StyledTextBlock,
  StyledTextWrapper,
} from '~/pages/HomePage/components/create-qr-poster/styled';
import { getIsDesktop } from '~/store/reducers/app/selectors';
import { COLORS } from '~/styles/colors';

import qrImg from './assets/qrImg.webp';

interface CreateQrPosterProps {
  className?: string;
}

export default function CreateQrPoster({ className = '' }: CreateQrPosterProps): JSX.Element {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const isDesktop = useSelector(getIsDesktop);

  const handleCreateClick = () => {
    navigate(PATH.SIGN_UP);
  };

  return (
    <StyledContainer className={className}>
      <StyledTextBlock>
        <StyledTextWrapper>
          <StyledText variant={isDesktop ? 'h1.5' : 'h2'}>{t('landing:createQRToday.title')}</StyledText>
          <StyledText variant={isDesktop ? 't18Medium' : 't16Medium'}>
            {t('landing:createQRToday.description')}
          </StyledText>
        </StyledTextWrapper>
        <StyledCreateButton onClick={handleCreateClick} hoverBackgroundColor={COLORS.primary}>
          {t('common:createQrCode')}
        </StyledCreateButton>
      </StyledTextBlock>
      <StyledImage src={qrImg} alt="QR code preview" />
    </StyledContainer>
  );
}
